import RiskProblemList from './RiskProblemList.vue';

export default RiskProblemList;
